import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';
import { DatePipe, Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  url: string = '/assets/menu.json';
configUrl:string='/assets/configMenu.json'
airUrl:string='/assets/airMenu.json'
menuItems:any
  constructor(private http: HttpClient,private userPrivileges:UserPrivilegeService) {

    this.userPrivileges.userMenuPrivileges().then((menuPrivileges:any) => {
      // console.log(menuPrivileges)
    this.menuItems = menuPrivileges
    /* for(let i=0;i<this.menuItems.length;i++)
     {
    if(this.menuItems[i].label==='Orders'){
       this.menuItems[i].label='Reports'
     }}*/
     //console.log(this.menuItems)
    
    } )
     .catch((error:any) => {
     //console.error(error); // Handle errors, if any
     });

   }
  async settingJson(){
    let json:any= fetch(this.url).then(res => res.json())
    .then(json => {
      // console.log(json)
      return json;
    });
   const res = await json
   
if(this.menuItems){
   res.menu=this.filterSubMenus(res.menu,this.menuItems.filter((item:any)=>item.label==='SettingMenu'))
  }else{
    res.menu=[]
   }
   return res
 }
 async ConfigJson(){
  let json:any= fetch(this.configUrl).then(res => res.json())
  .then(json => {
    return json;
  });

 const res = await json
 if(this.menuItems){
  res.menu=this.filterSubMenus(res.menu,this.menuItems.filter((item:any)=>item.label==='ConfigMenu'))
 }else{
  res.menu=[]
 }
 return  res
}
async airManageJson(){
  let json:any= fetch(this.airUrl).then(res => res.json())
  .then(json => {
    return json;
  });
 const res = await json
 return  res
}


transform(email: string): string {
  let result = '';

  for (let i = 0; i < email.length; i++) {
    const char = email.charCodeAt(i);
    result += char.toString(16); // Convert the character code to a hexadecimal string
  }

  return result;
}
decodeTransformed(encodedEmail: string): string {
  let result = '';

  for (let i = 0; i < encodedEmail.length; i += 2) {
    const hexChar = encodedEmail.slice(i, i + 2);
    const charCode = parseInt(hexChar, 16); // Convert the hexadecimal string to a character code
    result += String.fromCharCode(charCode);
  }

  return result;
}


privMenu(){
 

}


filterSubMenus = (data:any, label:any) => {
  // console.log(label)
  // Create a set of valid sub menu labels
  const validLabels = new Set(label[0].children.map((child:any) => child.label));
  

  // Filter each menu's subMenu based on the valid labels
  return data.map((menu:any) => {
      return {
          ...menu,
          subMenu: menu.subMenu.filter((sub:any) => validLabels.has(sub))
      };
  }) .filter((menu:any) => menu.subMenu.length > 0);
};

onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}
formatDate(val: Date) {
  let convertedValue:any = ""
  if(val){
  let datepipe = new DatePipe("en");
  //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
  convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
  }
  return convertedValue;
}
formatyyyy_MM_ddDate(val: Date) {
  let convertedValue:any = ""
  if(val){
  let datepipe = new DatePipe("en");
  //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
  convertedValue =  datepipe.transform(val, "yyyy-MM-dd");
  }
  return convertedValue;
}
}
